export default {
  nav: {
    title: 'Notes',
  },
  concepts: {
    note: {
      singular: 'note',
      plural: 'notes',
      title: 'Notes',
    },
    comment: {
      singular: 'comment',
      plural: 'comments',
      title: 'Comments',
    },
    feedback: {
      singular: 'feedback',
      plural: 'feedback',
      title: 'Feedback',
    },
  },
  card: {
    title: '{title}',
    count: '{count} {conceptPlural}',
    empty: 'No {conceptPlural} yet.',
    errorLoad: 'Unable to load {conceptPlural}.',
    formPlaceholder: 'Add a {conceptSingular}',
    formSubmit: 'Add {conceptSingular}',
    formSubmitting: 'Saving...',
    replyButton: 'Reply',
    replyingTo: 'Replying to this {conceptSingular}',
    replyCancel: 'Cancel',
    deleteButton: 'Delete',
    deletingButton: 'Deleting...',
    deleteConfirm: 'Delete this {conceptSingular}?',
    attachButton: 'Attach files',
    attachmentsLabel: 'Attachments',
    removeAttachment: 'Remove',
    uploadError: 'Unable to upload selected files.',
  },
}
